module.exports = __webpack_public_path__ + "img/ZAtop-SM250-60B-side.2df2d06a.jpg";